import { Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

// Import your translation files
import enTranslations from '../../../assets/i18n/en.json';
import itTranslations from '../../../assets/i18n/it.json';


@Injectable()
export class JsonFileLoader implements TranslateLoader {
  private translations: { [key: string]: TranslationObject } = {
    'en': enTranslations,
    'it': itTranslations,
  };
  
  getTranslation(lang: string): Observable<TranslationObject> {
    // Return the imported translations for the requested language
    const translation = this.translations[lang];
    

    if (translation) {
      return of(translation);
    }

    // Fallback to empty object if language not found
    return of({});
  }
}